//import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
const separator = (item) => (item / 100).toFixed(2).toString().replace('.', ',').replace(/\B(?!<\.\d*)(?=(\d{3})+(?!\d))/g, ".");

const convertNumber = (item) => item.replace(/\,/g, "").replace(/\./g, "");

const yesterday = () => {
  let now = new Date();
  now.setDate(now.getDate() - 1);
  let day = ("0" + now.getDate()).slice(-2);
  let month = ("0" + (now.getMonth() + 1)).slice(-2);
  let beforeDay = now.getFullYear() + month + day;
  return beforeDay;
}

const todayDate = () => {
  let now = new Date();
  let day = ("0" + now.getDate()).slice(-2);
  let month = ("0" + (now.getMonth() + 1)).slice(-2);
  let today = day + "." + month + "." + now.getFullYear();
  return today;
}
// Should have dd/MM/yyyy format for mobile-input-date's max-date and min-date;
const todayDateForMaxMin = () => {
  let now = new Date();
  let day = ("0" + now.getDate()).slice(-2);
  let month = ("0" + (now.getMonth() + 1)).slice(-2);
  let today = day + "/" + month + "/" + now.getFullYear();
  return today;
}
const getLastNYearsForMinDate = (n) => {
  let now = new Date();
  let lastYear = "01/01/" + (now.getFullYear() - n);
  return lastYear;
}
const getLastNYearsForMaxDate = (n) => {
  let now = new Date();
  let lastYear = "31/12/" + (now.getFullYear() - n);
  return lastYear;
}
// take input as "2021-01-26T00:00:00.000Z", returns yyyyMMdd as number
const getFormattedProcessDate = (dateInput) => {
  const selectedDate = dateInput.substring(0, 10).split('-')
  return parseInt(selectedDate[0] + selectedDate[1] + selectedDate[2])
}
const getFormattedDate = (dateInput) => {
  const selectedDate = dateInput.substring(0, 10).split('-')
  let today = selectedDate[2] + "/" + selectedDate[1] + "/" + selectedDate[0];
  return today;
}
const newDateTime = (now) => {
  let day = ("0" + now.getDate()).slice(-2);
  let month = ("0" + (now.getMonth() + 1)).slice(-2);
  let newDate = now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";
  return newDate;
}
const getTime = () => {
  let now = new Date();
  let h = ("0" + now.getHours()).slice(-2);
  let m = ("0" + now.getMinutes()).slice(-2);
  let time = h + ":" + m;
  return time;
}
const formatDate = (dateInput) => {
  return dateInput.split('/').reverse().join('');
}

const padTo2Digits = (num) => {
  return num.toString().padStart(2, '0');
}

const formatDate2 = (date) => {
  return [padTo2Digits(new Date(date).getDate()), (new Date(date).getMonth() + 1).toString().padStart(2, '0'), new Date(date).getFullYear()].join('.');
}

const formatDate3 = (date) => {
  let year = date.toString().substring(0, 4);
  let month = date.toString().substring(4, 6);
  let day = date.toString().substring(6, 8);
  return [day, month, year].join('.');
}

const calculateDayRange = (count) => {
  return formatDate2(new Date().setDate(new Date().getDate() - count));
}
const calculateMonthRange = (count) => {
  return formatDate2(new Date().setMonth(new Date().getMonth() - count));
}

const calculateBackYearRange = (count) => {
  return formatDate2(new Date().setFullYear(new Date().getFullYear() - count));
}
// return dd/MM/yyyy format for mobile-input-date's max-date and min-date;
const convertISOStringToMaxMinDate = (isoDate) => {
  const parts = isoDate.substring(0, 10).split('-');
  return parts[2] + '/' + parts[1] + '/' + parts[0]
}
// return like => "2021-01-26T00:00:00.000Z"
const addDay = (date, dayCount) => {
  const d = new Date(date);
  let afterDaysAdded = d.setDate(d.getDate() + dayCount);
  return new Date(afterDaysAdded).toISOString()
}
// return like => "2021-01-26T00:00:00.000Z"
const addMonth = (date, monthCount) => {
  const d = new Date(date);
  let afterMonthsAdded = d.setMonth(d.getMonth() + monthCount);
  return new Date(afterMonthsAdded).toISOString()
}


const getAccountType = (account) => {
  let accountTypeStr = "";
  const cartonType = account.cartonType || account.kartontipi;
  switch (cartonType) {
    case "T":
      accountTypeStr = "Ticari Kredi";
      break;
    case "B":
      accountTypeStr = "Bireysel Kredi";
      break;
    case "M":
      if (account.accountType == "V") {
        if (account.prodCode == "04030580000" || account.prodCode == "04030590000")
          accountTypeStr = "Endeksli";
        else
          accountTypeStr = "Vadeli";
      } else if (account.accountType == "S")
        accountTypeStr = "Vadesiz";
      else
        accountTypeStr = "Mevduat Hesabı";
      break;
    default:
      accountTypeStr = " ";
      break;
  }
  return accountTypeStr;
}

const changeDateFormat = (date) => {
  let newBaseD = date.toLocaleDateString(undefined, { month: '2-digit', day: '2-digit', year: 'numeric' });
  let newD = newBaseD.split('/')[1];
  let newM = newBaseD.split('/')[0];
  let newY = newBaseD.split('/')[2];
  return newD + "/" + newM + "/" + newY;
}

const validationUtils = {

  replaceWithArguments: (msg, replaceJson) => {
    let formattedMsg = msg;
    Object.keys(replaceJson).forEach((key) => {
      formattedMsg =
        formattedMsg.replace(new RegExp('\\[\\[' + key + '\\]\\]', 'gi'), replaceJson[key]);
    });
    return formattedMsg;
  }
};

const errorCodeValidator = (errorCode) => {
  if (Array.isArray(errorCode)) {
    errorCode = errorCode[0].statusCode;
  }
  if (
    (errorCode != '246114' && errorCode.startsWith('24')) ||
    errorCode == '990000' ||
    errorCode == '002023' ||
    errorCode == '004023' ||
    errorCode == '002052' ||
    errorCode == '999999'
  ) {
    return false;
  }
  return true;
};

const kriptoWithdrawErrorCodeValidator = (errorCode) => {
  if (
    errorCode == 'ERR000000086' ||
    errorCode == 'ERR000000165' ||
    errorCode == 'ERR000000087' ||
    errorCode == 'ERR000000168' ||
    errorCode == 'ERR000000098' ||
    errorCode == 'ERR000000069' ||
    errorCode == 'ERR000000070' ||
    errorCode == 'ERR000000071' ||
    errorCode == 'ERR000000171' ||
    errorCode == 'ERR000000028' ||
    errorCode == 'ERR000000085' ||
    errorCode == 'ERR000000170' ||
    errorCode == 'ERR0DTB00179'
  ) {
    return errorCode;
  }
  return '500';
};

const base64ToArrayBuffer = (base64) => {
  const binaryString = String.fromCharCode(...base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

const capitalizeFirstLatter = (string) => {
  return string?.split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + " ";
  })

}


const getDynamicParamsPayload = () => {
  const params = new URLSearchParams(window.location.search);
  const channelCode = params.get("channelCode");
  const dynamicParams = JSON.stringify({ channelCode });

  return dynamicParams;
}

const createCookie = (name, value, days) => {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  // Added SameSite=Lax for better session management
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/; secure; SameSite=Lax";
  console.log('[SESSION DEBUG] Utils cookie created:', name);
}

const readCookie = (name) => {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ')
      c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

const eraseCookie = (name) => {
  createCookie(name, "", -1);
}

const getChannelCode = () => {
  const pageMap = {
    ' #!/public-general': 'CSOGENELSAKLAMA',
    ' #!/public-kripto-general': 'CSOKRIPTOTSAKLAMA',
    'default': 'CSOSAKLAMA'
  };
  const page = localStorage.getItem('page');
  return pageMap[page] || pageMap['default'];
}

const getPageFromLocalStorage = () => {
  const page = localStorage.getItem('page');
  if (page === ' #!/public-kripto-general') {
    return 'kripto-general';
  } else if (page === ' #!/public-general') {
    return 'general';
  } else {
    return 'personal';
  }
}

const formatNumberWithCommas = (amount) => {
  const lang = readCookie('LANGUAGE_CODE') || 'tr-TR';
  if (lang === 'tr-TR') {
    try {

      if ((typeof amount !== 'string' && typeof amount !== 'number') || isNaN(amount)){
        throw new Error('Input must be a number', amount);
      }
      const parsedValue = parseFloat(amount);

      if (isNaN(parsedValue)) {
        throw new Error(`Value "${amount}" is not parsable to a float`);
      }
      // Convert the number to a string with two decimal places
      const [integerPart, fractionPart] = amount.toString().split('.');

      // Add thousands separator to the integer part
      const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      // If there's no fraction part, return the formatted integer part
      if (!fractionPart) {
        return formattedIntegerPart;
      }

      // Combine the formatted integer part with the fraction part
      return `${formattedIntegerPart},${fractionPart}`;
    } catch (error) {
      return amount; 
    }
  }
  return amount;
}

const checkCoinIcon = (coin) => {
  const coinList = ['aave',
    'ada',
    'arb',
    'avax',
    'btc',
    'chz',
    'dot',
    'eth',
    'grt',
    'inj',
    'ltc',
    'mana',
    'sand',
    'sol',
    'uni',
    'usdc',
    'xrp'];
  return coinList.includes(coin.toLowerCase());
}

export {
  separator,
  convertNumber,
  todayDate,
  formatDate,
  getTime,
  formatDate2,
  calculateDayRange,
  calculateMonthRange,
  calculateBackYearRange,
  newDateTime,
  getAccountType,
  validationUtils,
  errorCodeValidator,
  base64ToArrayBuffer,
  formatDate3,
  getFormattedProcessDate,
  getLastNYearsForMinDate,
  getLastNYearsForMaxDate,
  yesterday,
  capitalizeFirstLatter,
  addDay,
  todayDateForMaxMin,
  addMonth,
  convertISOStringToMaxMinDate,
  getDynamicParamsPayload,
  createCookie,
  readCookie,
  eraseCookie,
  getChannelCode,
  getPageFromLocalStorage,
  getFormattedDate,
  formatNumberWithCommas,
  kriptoWithdrawErrorCodeValidator,
  checkCoinIcon
};
